module.exports = __webpack_public_path__ + "static/img/4.c03b06a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/4.png
// module id = I+/j
// module chunks = 0